/*******************************************

* [COMPONENT]: CART DRAWER

  * Internal events:
    * - l:cart:updated: Fired when the cart is updated
    * - l:cart:discount:applied: Fired when a discount code is applied
  * External events
    * - l:product:added: Fired when a product is added to the cart
    * - l:cart:error: Fired when a cart error occurs
    *   ++ add 2 items into cart while product has only 1 item
********************************************/

class LTACartDrawer extends LTADrawer {
	constructor() {
		super()

		this.updatedVariants = []
		this._onQuantityChange = l_debounce(this._onQuantityChange.bind(this), 200)
		this._onRemoveLineItem = this._onRemoveLineItem.bind(this)
		this._onCartUpdate = this._onCartUpdate.bind(this)
	}

	connectedCallback() {
		if (super.connectedCallback) super.connectedCallback()

		this.updatedVariants = []

		this.addEventListener('change', this._onQuantityChange)
		this.addEventListener('click', this._onRemoveLineItem)

		document.addEventListener('l:product:added', this._onCartUpdate)
		document.addEventListener('l:cart:error', this._onCartUpdate)
		document.addEventListener('l:cart:discount:applied', this._onCartUpdate)
	}

	drawer_close() {
		if (super.drawer_close) super.drawer_close()

		this.dispatchEvent(
			new CustomEvent('l:cart:closed', {
				bubbles: true,
				detail: { updatedVariants: this.updatedVariants },
			})
		)

		this.updatedVariants = []
	}

	_onRemoveLineItem(event) {
		const removeBtn = event.target.closest('[data-remove-line-item]')
		if (!removeBtn) return

		event.preventDefault()

		const lineItemEl = event.target.closest('[data-drawer-line-item]')
		if (lineItemEl) {
			this._updateCartLine(lineItemEl, 0)
		}
	}

	_onQuantityChange(event) {
		const lineItemEl = event.target.closest('[data-drawer-line-item]')
		if (!lineItemEl) return

		const quantity = parseInt(event.target.value || 1, 10)

		this._updateCartLine(lineItemEl, quantity)
	}

	_updateCartLine(lineItemEl, quantity) {
		if (!lineItemEl) return

		this.classList.add('is-loading')

		const line = parseInt(lineItemEl.dataset.index, 10)
		const variantId = lineItemEl.dataset.variantId

		ltaCartService
			.changeCartLineItem({
				line,
				quantity,
				sections_url: window.location.pathname,
				sections: this._getSectionsToRender().map((section) => section.id),
			})
			.then((cart) => {
				if (cart?.status === 422) {
					this._handleCartError(cart, lineItemEl)

					return
				}

				this._updateCartData(cart.sections[this.dataset.sectionId])

				this.dispatchEvent(new CustomEvent('l:cart:updated', { detail: { cart }, bubbles: true }))
				this.updatedVariants.push(variantId)
			})
			.catch((error) => {
				console.error(error)
			})
			.finally(() => {
				this.classList.remove('is-loading')
			})
	}

	_handleCartError(error = { description: '' }, lineItemEl) {
		// Add error message to line item
		const errorMessageEl = lineItemEl.querySelector('[data-error-message]')

		if (errorMessageEl) {
			errorMessageEl.innerHTML = error.description
			errorMessageEl.parentElement.classList.remove('l-hidden')
		}

		// Dispatch event
		// this.dispatchEvent(
		// 	new CustomEvent('l:cart:error', {
		// 		detail: { id: 'cart-drawer', description: error.description },
		// 		bubbles: true,
		// 	})
		// )
	}

	_onCartUpdate() {
		this.drawer_open?.()
		this.classList.add('is-loading')

		fetch(`${window.LTATheme.routes.cart_url}?section_id=${this.dataset.sectionId}`)
			.then((res) => res.text())
			.then((html) => {
				this._updateCartData(html)
			})
			.finally(() => {
				this.classList.remove('is-loading')
			})
	}

	_updateCartData(html) {
		if (!this.classList.contains('is-active')) this.drawer_open?.()

		const newCartDrawerHTML = l_getSectionDOM(html, '#cart-drawer')
		this.classList.toggle('is-empty', newCartDrawerHTML?.classList.contains('is-empty'))

		const selectors = [
			'[data-drawer-header]',
			'[data-cart-inner]',
			'[data-cart-subtotal]',
			'[data-discount-code-container]',
			'#cart-drawer-form',
			'[data-cart-footer]',
		]

		selectors.forEach((selector) => {
			const newSection = newCartDrawerHTML?.querySelector(selector)
			const oldSection = this.querySelector(selector)
			if (newSection && oldSection) oldSection.innerHTML = newSection.innerHTML
		})
	}

	_getSectionsToRender() {
		return [
			{
				id: this.dataset.sectionId,
				selector: '.shopify-section',
			},
		]
	}
}

customElements.define('l-cart-drawer', LTACartDrawer)

